import {useTranslation} from '@aboutyou/i18n';
import {
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  Heading16,
  Paragraph14,
  RadioButton,
  RadioGroup,
  UnstyledButton,
  mediaTabletAndUp,
} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
// eslint-disable-next-line import/no-extraneous-dependencies
import {emailRegex} from '@aboutyou/utils';
import {useForm} from 'react-hook-form';

interface SubscriptionFormData {
  email: string;
  gender: 'male' | 'female';
}

const CountryLaunchNewsLetter: React.FC<{
  onNewsletterSubscribe: (data: SubscriptionFormData) => void;
}> = ({onNewsletterSubscribe}) => {
  const {t} = useTranslation();
  const {
    handleSubmit,
    register,
    formState: {errors},
    reset,
  } = useForm<SubscriptionFormData>({
    defaultValues: {
      email: '',
      gender: 'female',
    },
    mode: 'onSubmit',
  });

  const newsletterPreLaunchDate = '25.04.2022';
  const officialLaunchDate = '26.04.2022';

  const submitHandler = (data: SubscriptionFormData) => {
    onNewsletterSubscribe(data);
    reset();
  };

  return (
    <NewsletterSection>
      <NewsletterHeading>
        {t(
          'Just subscribe to our newsletter to find out before the official launch and everyone else.As a bonus, you’ll get a f***ing special surprise on top!.In the meantime, feel free to spread the rumours.',
        )}
      </NewsletterHeading>

      <NewsletterSubHeading>
        {t(
          `Exclusive pre-launch for newsletter subscribers only: {newsletterPreLaunchDate}`,
          {
            newsletterPreLaunchDate,
          },
        )}
      </NewsletterSubHeading>
      <NewsletterSubHeading>
        {t(`Official launch: {officialLaunchDate}`, {
          officialLaunchDate,
        })}
      </NewsletterSubHeading>
      <form
        autoComplete="on"
        onSubmit={handleSubmit(submitHandler)}
        method="POST"
      >
        <>
          <Container>
            <EmailInput
              type="email"
              placeholder={t('Your Email address')}
              {...register('email', {
                required: t('Please enter your email address'),
                pattern: {
                  value: emailRegex,
                  message: t('This is not a valid email address'),
                },
              })}
            />

            <SubmitButton type="submit">{t('Subscribe')}</SubmitButton>

            {errors.email && <Hint isError>{errors.email.message}</Hint>}
          </Container>

          <GenderContainer>
            <RadioButton
              label={t('For women')}
              {...register('gender')}
              value={'female'}
              className="radio-white"
              id="gender female"
            />

            <RadioButton
              label={t('For men')}
              {...register('gender')}
              value={'male'}
              className="radio-white"
              id="gender male"
            />
          </GenderContainer>

          {errors.gender && <Hint isError>{errors.gender.message}</Hint>}
        </>
      </form>
      <NewsletterUnsubscribeNote>
        {t(
          'I want to receive information on current trends, offers and vouchers per email in the future.It is possible to unsubscribe from the newsletter at any time without cost',
        )}
      </NewsletterUnsubscribeNote>
    </NewsletterSection>
  );
};

const NewsletterHeading = styled(Heading16)`
  line-height: 24px;
  font-weight: ${FONT_WEIGHTS.light};
  margin-bottom: 30px;
  color: ${COLORS.White} !important;
`;

const NewsletterSubHeading = styled(NewsletterHeading)`
  margin-bottom: 5px;
`;

const NewsletterSection = styled.section`
  margin: 40px 0px;
`;

const NewsletterUnsubscribeNote = styled(Paragraph14)`
  line-height: 1.54;
  margin-top: 20px;
  color: ${COLORS.White};
`;

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 10px;
`;

const GenderContainer = styled(RadioGroup)`
  margin-top: 20px;

  .radio-white {
    & > div {
      border-color: ${COLORS.White};
    }

    span {
      color: ${COLORS.White};
    }

    input {
      &:checked,
      &:focus {
        & ~ div {
          border-color: ${COLORS.White};

          &::after {
            background-color: ${COLORS.White};
          }
        }

        & ~ span {
          color: ${COLORS.White};
        }
      }
    }
  }
`;

const EmailInput = styled.input`
  width: 52%;
  padding: 12px 10px;
  color: ${COLORS.Black};
  font-size: ${FONT_SIZES.px14};
  letter-spacing: 0.95px;
  outline: none;
  border: none;
`;

const SubmitButton = styled(UnstyledButton)`
  appearance: none;
  border: none;
  padding: 12px 20px;
  background-color: ${COLORS.Blue4};
  color: ${COLORS.White};
  width: 35%;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.8px;
  cursor: pointer;

  @media ${mediaTabletAndUp} {
    padding: 12px 40px;
  }
`;

const Hint = styled.span<{isError?: boolean}>`
  font-size: 13px;
  font-weight: 500;
  line-height: 1.54;
  margin-top: 5px;
  display: block;
  color: ${({isError}) => (isError ? COLORS.Red : COLORS.Green)};
`;

export {CountryLaunchNewsLetter};
